<!-- a detail cell for customer details table -->
<script lang="ts">
  import VanillaContextMenu from "vanilla-context-menu"

  let {
    label,
    value = undefined,
    href = undefined,
    valueClass = "",
  } = $props<{
    label: string
    value?: string | boolean | undefined
    href?: string | undefined
    valueClass?: string
  }>()

  // oxlint-disable-next-line @typescript-eslint/no-unused-vars
  let menu = $state<null | VanillaContextMenu>(null)

  const updateMenu = (event: MouseEvent) => {
    menu = new VanillaContextMenu({
      scope: event.currentTarget as HTMLElement,
      menuItems: [
        {
          label: "Copy",
          callback: () => {
            navigator.clipboard.writeText(value?.toString() ?? "")
          },
          preventCloseOnClick: false,
        },
      ],
      normalizePosition: false,
      transitionDuration: 0,
      theme: "white",
      customClass: "context-menu",
    })
  }
</script>

<div
  class="flex w-full items-center justify-between text-nowrap border-t-[1px] border-black text-sm"
>
  <p class="mr-2">{label}</p>
  <!--
    The mouseenter handler attaches a cosmetic right-click "Copy value" menu;
    the span itself is non-interactive and not keyboard-reachable, so the
    static-element-interactions warning does not apply here.
  -->
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <span
    data-testid="{label} value"
    class="truncate {valueClass}"
    onmouseenter={(event) => {
      updateMenu(event)
    }}
  >
    {#if href}
      <a
        class="text-blue-700 underline"
        target="_blank"
        rel="noopener noreferrer"
        {href}>{value ?? ""}</a
      >
    {:else}
      <span class="select-text" title={value?.toString()}>{value ?? ""}</span>
    {/if}
  </span>
</div>
